module.exports = __webpack_public_path__ + "img/but-l.b98a61a5.png";